import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Distintivos from "@/components/Distintivos";
import Servicios from "@/components/Servicios";
import Clientes from "@/components/Clientes";
import Testimonios from "@/components/Testimonios";
import Contacto from "@/components/Contacto";
import Footer from "@/components/Footer";
import useReveal from "@/hooks/useReveal";
import { Toaster } from "@/components/ui/sonner";

export default function Landing() {
  const ref = useReveal();

  useEffect(() => {
    document.title =
      "Sagitta Corporativo — Nobleza, Precisión y Blindaje Jurídico-Financiero";
  }, []);

  return (
    <div ref={ref} className="bg-white text-neutral-950 font-sans-pro">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Distintivos />
        <Servicios />
        <Clientes />
        <Testimonios />
        <Contacto />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}
